import { ResponsiveTheme } from "../.internal/themes/ResponsiveTheme";
export default ResponsiveTheme;
//# sourceMappingURL=Responsive.js.map